import React from 'react';

// Renders plain text with markdown links [text](url) and **bold** as React elements
export function renderChatMessage(content) {
  const pattern = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)|\*\*([^*]+)\*\*/g;
  const elements = [];
  let lastIndex = 0;
  let match;
  let key = 0;

  while ((match = pattern.exec(content)) !== null) {
    if (match.index > lastIndex) {
      elements.push(content.slice(lastIndex, match.index));
    }
    if (match[1] !== undefined) {
      elements.push(
        <a key={key++} href={match[2]} target="_blank" rel="noopener noreferrer"
          className="underline text-blue-400 hover:text-blue-300">
          {match[1]}
        </a>
      );
    } else {
      elements.push(<strong key={key++}>{match[3]}</strong>);
    }
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < content.length) {
    elements.push(content.slice(lastIndex));
  }

  return elements;
}
